<template>
  <div class="cal-anual">
    <div class="cal-anual__header">
      <div class="cal-anual__title">
        <v-icon left small class="mr-2">mdi-calendar-multiselect</v-icon>
        Calendário de Formações
      </div>
      <div class="cal-anual__center">
        <v-select
          :items="anosDisponiveis"
          v-model="anoInterno"
          dense
          outlined
          hide-details
          class="cal-anual__select"
          label="Ano"
        />
      </div>
      <div class="cal-anual__spacer"></div>
    </div>
    <v-row dense>
      <v-col v-for="m in 12" :key="m" cols="12" sm="6" md="4" lg="3">
        <v-card class="month-card" :elevation="0">
          <div
            class="month-card__header"
            :class="{
              'month-card__header--disabled': !mesClicavel(m),
              'month-card__header--current': isMesAtual(m)
            }"
            @click="onClickMes(m)"
            role="button"
            :aria-disabled="!mesClicavel(m)"
            :aria-label="`Abrir ${nomeMes(m)} de ${anoInterno}`"
          >
            <div class="month-card__title">
              <v-icon left small class="mr-2">mdi-calendar-month</v-icon>
              <span>{{ nomeMes(m) }}</span>
              <span v-if="isMesAtual(m)" class="current-chip" aria-hidden="true">ATUAL</span>
            </div>
          </div>
          <v-divider class="month-card__divider" />
          <v-calendar
            :value="`${anoInterno}-${pad(m)}-01`"
            type="month"
            :events="eventosNormalizados"
            locale="pt-BR"
            :weekdays="[1,2,3,4,5,6,0]"
            :short-weekdays="true"
            :show-adjacent-months="false"
            :hide-header="false"
            class="month-card__calendar"
          >
            <template #day="slot">
              <div class="day-cell no-pointer" :class="dayClasses(slot)">
                <div class="paint" :style="getDayStyle(slot)"></div>
                <span class="day-num">{{ getDayNumber(slot) }}</span>
              </div>
            </template>
          <template #day-label="{ day }">
            <span class="day-num">{{ day.day }}</span>
          </template>
          </v-calendar>
        </v-card>
      </v-col>
    </v-row>
    <div class="legend-global">
      <div class="legend-global__item">
        <span class="legend-global__dot" :style="{ background: palette.SEE }"></span>
        Formação SEE
      </div>
      <div class="legend-global__item">
        <span class="legend-global__dot" :style="{ background: palette.Escola }"></span>
        Formação Escola
      </div>
      <div class="legend-global__item">
        <span class="legend-global__dot" :style="{ background: palette.GRE }"></span>
        Formação GRE
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalendarioAnualFormacoes',
  props: {
    ano: { 
      type: Number, 
      default: () => new Date().getFullYear()
    },
    eventos: { type: Array, default: () => [] },
    coresPorTipo: { type: Object, default: () => ({}) },
    mesInicio: { type: Number, default: 1 },
    mesFinal: { type: Number, default: 12 },
    anosDisponiveis: { type: Array, default: () => [] },
  },
  data () {
    return {
      anoInterno: this.ano,
      coresFixasDefault: {
        SEE:   '#f8a5c2',
        Escola:'#bde0a8',
        GRE:   '#a5c8ff',
      },
      mesAtual: new Date().getMonth() + 1,
      anoCorrente: new Date().getFullYear(),
    }
  },
  computed: {
    palette () {
      const inferidas = {}
      const normalizeTipo = (t) => {
        const v = String(t || '').toLowerCase()
        if (v === 'see' || v === 'secretaria' || v === 'estado') return 'SEE'
        if (v === 'gre') return 'GRE'
        return 'Escola'
      }
      for (const e of (this.eventos || [])) {
        if (e && e.cor) {
          const key = normalizeTipo(e.tipo)
          inferidas[key] = e.cor
        }
      }
      return { ...this.coresFixasDefault, ...inferidas, ...(this.coresPorTipo || {}) }
    },

    eventosNormalizados () {
      const out = []
      const normalizeTipo = (t) => {
        const v = String(t || '').toLowerCase()
        if (v === 'see' || v === 'secretaria' || v === 'estado') return 'SEE'
        if (v === 'gre') return 'GRE'
        return 'Escola'
      }

      for (const e of (this.eventos || [])) {
        if (e && e.date) {
          out.push({ start: String(e.date).slice(0,10), tipo: normalizeTipo(e.tipo) })
          continue
        }
        const ini = e?.dataInicio ? new Date(e.dataInicio) : null
        const fim = e?.dataFim ? new Date(e.dataFim) : null
        if (ini instanceof Date && !isNaN(+ini) && fim instanceof Date && !isNaN(+fim)) {
          const tipo = normalizeTipo(e.tipo)
          for (let d = new Date(ini); d <= fim; d.setDate(d.getDate() + 1)) {
            const yyyy = d.getFullYear()
            const mm = String(d.getMonth() + 1).padStart(2, '0')
            const dd = String(d.getDate()).padStart(2, '0')
            out.push({ start: `${yyyy}-${mm}-${dd}`, tipo })
          }
        }
      }
      return out
    },
    tiposPorData () {
      const map = new Map()
      for (const ev of this.eventosNormalizados) {
        if (!ev.start) continue
        const arr = map.get(ev.start) || []
        if (ev.tipo && !arr.includes(ev.tipo)) arr.push(ev.tipo)
        map.set(ev.start, arr)
      }
      return map
    },
    eventCountByMonth () {
      const counts = Array.from({ length: 13 }, () => 0)
      for (const [iso, tipos] of this.tiposPorData.entries()) {
        if (!tipos?.length) continue
        const [y, m] = iso.split('-').map(Number)
        if (y === this.anoInterno && m >= 1 && m <= 12) counts[m]++
      }
      return counts
    },
  },
  watch: {
    ano (n) { this.anoInterno = n }
  },
  methods: {
    pad (n) { return n.toString().padStart(2, '0') },
    nomeMes (m) {
      const data = new Date(this.anoInterno, m - 1, 1)
      const mes = data.toLocaleDateString('pt-BR', { month: 'long' })
      return mes.charAt(0).toUpperCase() + mes.slice(1)
    },
    mesClicavel (m) { return m >= this.mesInicio && m <= this.mesFinal },
    onClickMes (m) { if (this.mesClicavel(m)) this.$emit('abrirMes', { ano: this.anoInterno, mes: m }) },
    isMesAtual (m) {
      return m === this.mesAtual && this.anoInterno === this.anoCorrente
    },
    toISODate (slot) {
      if (slot && typeof slot.start === 'string' && /^\d{4}-\d{2}-\d{2}/.test(slot.start)) return slot.start.slice(0, 10)
      if (slot && typeof slot.date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(slot.date)) return slot.date.slice(0, 10)
      if (slot && slot.day && typeof slot.day.date === 'string') return slot.day.date.slice(0, 10)
      if (typeof slot === 'string') {
        if (/^\d{4}-\d{2}-\d{2}/.test(slot)) return slot.slice(0, 10)
        const d = new Date(slot); if (!isNaN(d)) return `${d.getFullYear()}-${this.pad(d.getMonth()+1)}-${this.pad(d.getDate())}`
        return null
      }
      if (slot instanceof Date) return `${slot.getFullYear()}-${this.pad(slot.getMonth()+1)}-${this.pad(slot.getDate())}`
      return null
    },
    getDayNumber (slot) {
      const iso = this.toISODate(slot)
      if (!iso) return ''
      return new Date(iso + 'T00:00:00').getDate()
    },
    isWeekend (slot) {
      const iso = this.toISODate(slot)
      if (!iso) return false
      const wd = new Date(iso + 'T00:00:00').getDay()
      return wd === 0 || wd === 6
    },
    dayClasses (slot) {
      const iso = this.toISODate(slot)
      const has = !!(iso && this.tiposPorData.get(iso)?.length)
      return { 'is-weekend': this.isWeekend(slot), 'has-event': has }
    },

    getDayStyle (slot) {
      const iso = this.toISODate(slot)
      if (!iso) return {}
      const d = new Date(iso + 'T00:00:00')
      if (d.getFullYear() !== this.anoInterno) return {}

      const tipos = this.tiposPorData.get(iso) || []
      if (tipos.length === 0) return {}

      const P = this.palette
      if (tipos.length === 1) return { background: P[tipos[0]] }
      if (tipos.length === 2) {
        const [a, b] = tipos
        return { background: `linear-gradient(90deg, ${P[a]} 0 50%, ${P[b]} 50% 100%)` }
      }
      const [a, b, c] = tipos
      return { background: `linear-gradient(90deg, ${P[a]} 0 33.333%, ${P[b]} 33.333% 66.666%, ${P[c]} 66.666% 100%)` }
    },
  },
}
</script>

<style scoped>
/* ===== Topbar ===== */
.cal-anual__header{
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.cal-anual__title{
  display:flex; align-items:center;
  font-size:20px; font-weight:700; letter-spacing:.2px;
  justify-self: start;
}
.cal-anual__center{ justify-self: center; }
.cal-anual__spacer{}
@media (max-width: 640px){
  .cal-anual__header{ grid-template-columns: 1fr; }
  .cal-anual__title{ justify-self:center; text-align:center; }
  .cal-anual__center{ justify-self:center; }
  .cal-anual__spacer{ display:none; }
}

.cal-anual__select{
  width: 160px;
  max-width: 40vw;
}

/* ===== Mes card ===== */
.month-card{
  border-radius:16px;
  background: linear-gradient(180deg, rgba(255,255,255,.9), rgba(255,255,255,.78));
  border: 1px solid rgba(15,23,42,.06);
  box-shadow: 0 8px 24px rgba(15,23,42,.06);
  overflow:hidden;
  display:flex; flex-direction:column;
  height: 340px;
  transition: transform .2s ease, box-shadow .2s ease;
}
.month-card:hover{
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(15,23,42,.10);
}

/* Header do mês */
.month-card__header{
  display:flex; align-items:center; gap:10px;
  padding:12px 14px;
  background: linear-gradient(90deg, #f7f9fc, #eef2ff);
  color:#0f172a;
  cursor:pointer;
  font-weight:700;
  text-transform:capitalize;
  border-left: 4px solid transparent;
}
.month-card__header--disabled{ opacity:.45; cursor:not-allowed; text-decoration: line-through; }
.month-card__title{ display:flex; align-items:center; }

/* mês atual */
.month-card__header--current{
  background: linear-gradient(90deg, #eff6ff, #dbeafe);
  border-left-color: #3b82f6;
}
.current-chip{
  margin-left:8px;
  background:#3b82f6;
  color:#fff;
  font-size:10px;
  font-weight:700;
  padding:2px 6px;
  border-radius:999px;
  letter-spacing:.3px;
}

/* pill de densidade */
.density-pill{
  margin-left:auto;
  padding:2px 9px;
  border-radius:999px;
  font-size:12px; font-weight:700;
  background:#0ea5e9; color:#fff;
  box-shadow: 0 2px 6px rgba(14,165,233,.35);
}
.density-pill--zero{
  background:#cbd5e1; color:#0f172a;
  box-shadow:none;
}

.month-card__divider{ opacity:.45; }
.month-card__calendar{ flex:1; padding:8px; height:100% !important; }

/* ===== Célula do dia ===== */
.day-cell{
  position: relative;
  width:100%; height:100%;
  display:flex; align-items:center; justify-content:center;
  border-radius:10px; box-sizing:border-box;
  font-variant-numeric: tabular-nums;
  user-select: none;
}
.day-cell::before{
  content:"";
  position:absolute; inset:3px;
  border-radius:10px;
  background: var(--day-bg, transparent);
  z-index:1;
  box-shadow: 0 0 0 1px rgba(15,23,42,.05) inset;
}
.day-num{
  position: relative; z-index:2;
  font-size:13px; font-weight:700; line-height:1;
  color:#0f172a;
}
.paint{
  position:absolute;
  inset:3px;
  border-radius:10px;
  z-index:1;
  box-shadow: 0 0 0 1px rgba(15,23,42,.05) inset;
  /* sem background aqui; vem inline via :style */
}

/* finais de semana sem evento */
.day-cell.is-weekend:not(.has-event)::before{
  background:#eef6ff;
}

/* ===== Tornar dias 100% não interativos ===== */
.no-pointer{ pointer-events: none; }
:deep(.v-calendar-month__day){ cursor: default !important; }
:deep(.v-calendar-month__day:hover){ background: transparent !important; }
:deep(.v-calendar-month__day--active),
:deep(.v-calendar-weekly__day--active),
:deep(.v-calendar-weekly__day .v-btn--active),
:deep(.v-calendar-month__day .v-btn--active){
  background-color: transparent !important;
  box-shadow: none !important;
}
:deep(.v-calendar-month__day:focus),
:deep(.v-calendar-weekly__day:focus){
  outline: none !important;
}

/* ===== Ajustes do calendário ===== */
:deep(.v-calendar-month__days){ gap:6px; }
:deep(.v-calendar-month__day){ position: relative; }
:deep(.v-event){ display:none !important; }
:deep(.v-calendar-weekly__head .v-btn),
:deep(.v-calendar-monthly__head .v-btn){
  text-transform: none;
  font-weight: 600;
  letter-spacing: .2px;
  color:#334155;
}

/* ===== Legenda global ===== */
.legend-global{
  display:flex; gap:18px; align-items:center; flex-wrap:wrap;
  margin-top:18px; padding:10px 12px;
  border:1px dashed rgba(15,23,42,.08);
  background: #fbfcff;
  border-radius: 12px;
}
.legend-global__item{
  display:inline-flex; gap:8px; align-items:center;
  font-size:13px; color:#334155; font-weight:600;
}
.legend-global__dot{
  width:12px; height:12px; border-radius:999px; display:inline-block;
  box-shadow: 0 0 0 1px rgba(15,23,42,.06) inset;
}
</style>
